import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { OverviewDTO } from '../../../api/useOverviewQuery';
import { useClientId } from '../../../../_hooks/useClientId';
import { getPersonaIcon } from '../../../utils/getPersonaIcon';
import { useIsMobile } from '../../../../_hooks/useIsMobile';

interface Props {
  data: OverviewDTO;
}

export const Persona = ({ data }: Props) => {
  const clientId = useClientId();

  const isMobile = useIsMobile();

  const { category, score, title, description } = data.persona;

  return (
    <Box as="section" css="text-align: center">
      <Text as="p" variant="smallCaps" mb="16">
        Your financial persona
      </Text>

      <Icon
        className={getPersonaIcon({ persona: category, score })}
        fontSize="xxl"
        color="neutral.700"
        mb="16"
        aria-hidden="true"
      />

      <Text
        as="h1"
        fontSize={isMobile ? 'h2' : 'xl'}
        fontWeight={700}
        mb="24"
        css={`
          line-height: ${isMobile ? '40px' : '56px'};
        `}
      >
        {title}
      </Text>

      <Text
        as="p"
        fontSize={isMobile ? 'h6' : 'h5'}
        fontWeight={500}
        color="neutral.600"
        mx={isMobile ? 0 : '56'}
        mb="40"
        textAlign={isMobile ? 'left' : 'center'}
        css="line-height: 24px"
      >
        {description}
      </Text>

      <Button
        onClick={() => {
          ADV.util.Router.go2('BeFi20Results', { clientId });
        }}
      >
        View Details
      </Button>
    </Box>
  );
};
